// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.enums.AnalyticsAffordableRentBracket

export enum AnalyticsAffordableRentBracket {
  BRACKET_1500_2K = 'BRACKET_1500_2K',
  BRACKET_1K_1500 = 'BRACKET_1K_1500',
  BRACKET_2K_3K = 'BRACKET_2K_3K',
  BRACKET_3K_4K = 'BRACKET_3K_4K',
  BRACKET_4K_PLUS = 'BRACKET_4K_PLUS',
  UNDER_1K = 'UNDER_1K',
}

export const AnalyticsAffordableRentBracket_values = [
  AnalyticsAffordableRentBracket.BRACKET_1500_2K,
  AnalyticsAffordableRentBracket.BRACKET_1K_1500,
  AnalyticsAffordableRentBracket.BRACKET_2K_3K,
  AnalyticsAffordableRentBracket.BRACKET_3K_4K,
  AnalyticsAffordableRentBracket.BRACKET_4K_PLUS,
  AnalyticsAffordableRentBracket.UNDER_1K,
] as const;
